import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/pixel';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  scrollTo?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  fullWidth = false,
  scrollTo = 'pricing',
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      trackAddToCart();
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    if (onClick) {
      onClick();
      return;
    }
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02,
    backgroundColor: '#5E1F2B',
    boxShadow: '0 4px 12px rgba(123, 45, 59, 0.2)'
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-wine text-linen font-serif font-medium text-lg px-8 py-4 rounded-sm shadow-sm
        transition-all duration-300 ease-in-out tracking-wide
        border border-wine/20
        ${fullWidth ? 'w-full' : 'w-full sm:w-auto'}
        ${className}
      `} data-id="element-21">
      {children}
    </motion.button>;
}